import React from 'react'
import './QuoteCard.css'

const QuoteCard = ({ QuoteText, children }) => (
  <div className="fmbm-quote-card wow animated fadeIn">
    <div className="fmbm-quote-card__quote">
      <p>{QuoteText}</p>
    </div>

    <div className="fmbm-quote-card__contents">{children}</div>
  </div>
)

export default QuoteCard



// WEBPACK FOOTER //
// ./src/Components/QuoteCard/QuoteCard.js